export default __webpack_public_path__ + "static/media/skyscend-pay.801fa7da.png";